// eslint-disable-next-line import/prefer-default-export
export enum JustificationMigrationCompeting {
  MIGRATION_TO_COMPETING_FIRM = 'd65e5f15-1221-4412-b514-bda90325df44'
}
